import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const GeoRangeInline = ({ range, updateRange, geoRangeLabel }) => {
	const { geoRadiusValues } = window.DDC.InvData.getGeoDataPrefs() || {};
	const labels = useLabels();

	if (!geoRadiusValues) {
		return <></>;
	}

	const getRadiusValues = () => {
		const optionsArr = [];

		geoRadiusValues.split(',').forEach((value) => {
			const isAnyDistance = value === '0';

			optionsArr.push({
				value,
				label: isAnyDistance
					? `${labels.get('ANY')}`
					: `${value} ${labels.get('MILES')}`
			});
		});

		return optionsArr;
	};

	const distanceShippingOption = geoRangeLabel
		? { id: 'distance-shipping-label-zip' }
		: {};

	return (
		<div>
			<span className="ddc-font-size-xsmall">
				{labels.get('DISTANCE')}
			</span>
			<select
				className="form-control ddc-font-size-base"
				aria-label={labels.get('ZIP_CODE_RANGE_DROPDOWN')}
				onChange={updateRange}
				value={range}
				{...distanceShippingOption}
			>
				{getRadiusValues(geoRadiusValues).map(({ value, label }) => (
					<option key={value} value={value}>
						{label}
					</option>
				))}
			</select>
		</div>
	);
};

GeoRangeInline.propTypes = {
	range: PropTypes.string.isRequired,
	updateRange: PropTypes.func.isRequired,
	geoRangeLabel: PropTypes.string
};

export default GeoRangeInline;
